import { render, staticRenderFns } from "./WhatsAppGroupView.vue?vue&type=template&id=feb0475c"
import script from "./WhatsAppGroupView.vue?vue&type=script&lang=js"
export * from "./WhatsAppGroupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports